import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=83e23f96&scoped=true"
import script from "./permissions.js?vue&type=script&lang=js&external"
export * from "./permissions.js?vue&type=script&lang=js&external"
import style0 from "./permissions.scss?vue&type=style&index=0&id=83e23f96&prod&lang=scss&scoped=true&external"
import style1 from "./permissions.vue?vue&type=style&index=1&id=83e23f96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e23f96",
  null
  
)

export default component.exports